import {useState} from 'external/react'

import {
    Button,
    Box,
    FormControlLabel,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useTheme,
    useMediaQuery,
    WarningIcon,
    styled,
    clsx
} from 'external/material'

import { createPost } from 'utils/command'
import useTranslations from 'hooks/translations'
import useProfile from 'hooks/profile'

const StyledDialog = styled(Dialog)(notificationStyles)

export default function Notification () {

  const {translate} = useTranslations()
  const {preferences: {properties, loaded}, settings: {showTopbarNotification: notificationPrefix}, update} = useProfile()

  const open = loaded && notificationPrefix
    ? !properties.notifications[notificationPrefix]
    : false

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('desktop'))

  const [stopNotification, setStopNotification] = useState(false)

  async function onConfirm () {
    const {preferences: {properties}} = await update({preferences: {properties: {notifications: {[notificationPrefix]: {$set: true}}}}})
    if (stopNotification)
      createPost('public', 'preferences')({properties})
  }

  return (
    <StyledDialog
      fullScreen={fullScreen}
      open={open}
      onClose={e => close(e)}
      maxWidth="desktop"
      aria-labelledby={`${notificationPrefix}-notification-dialog-title`}
    >
      <DialogTitle id={`${notificationPrefix}-notification-dialog-title`} className="notification-dialog-title">
        <Box className="icon"><WarningIcon /></Box>
        <Box>{translate(`${notificationPrefix}-notification-dialog-title`)}</Box>
      </DialogTitle>
      <DialogContent className="content">
        <div className="notification" dangerouslySetInnerHTML={{__html: translate(`${notificationPrefix}-notification-html`)}} />
      </DialogContent>

      <DialogActions className="actions">
        <FormControlLabel
          size="small"
          className="stopNotification"
          control={
            <Checkbox
              size="small"
              color="primary"
              checked={stopNotification} 
              onChange={e => setStopNotification(e.target.checked)}
            />
          }
          label={translate('stop-showing')}
        />
        <div className="filler" />
        <Button
          variant="contained"
          color="primary"
          className={clsx("button", "confirm")}
          onClick={onConfirm}>
            {translate('continue')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}

function notificationStyles() {
  return {
    "& .notification-dialog-title": {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '16pt',
      fontWeight: 'bold',
      borderBottom: 'solid 1px #f3f3f3',
      background: '#fdfdfd'
    },
    "& .icon": {
      color: 'red',
      fontSize: '15pt',
      marginTop: -1,
      marginRight: 10
    },
    "& .notification": {
      padding: '0 15px',
      "& ol": {
        padding: '8px 40px'
      },
      "& li": {
        marginTop: 10,
        "&:first-of-type": {
          marginTop: 0
        }
      }
    },
    "& .actions": {
      padding: 12,
      display: 'flex',
      borderTop: 'solid 1px #f3f3f3',
      background: '#fdfdfd'
    },
    "& .filler": {
      flexGrow: 1
    },
    "& .button": {
      textTransform: 'none'
    }
  }
}
